import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllNewsLetter() {
  return useMutation({
    mutationFn: ({ page, limit, role, search }) => {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit)
      });

      if (role) {
        params.append("role", role);
      }

      if (search) {
        params.append("search", search);
      }

      return apiClient({
        url: `admin/news-letter/all?${params.toString()}`,
        method: "GET"
      });
    }
  });
}

export function useUpdateNewsLetter() {
  return useMutation({
    mutationFn: ({ subscriberId, payload }) =>
      apiClient({
        url: `admin/news-letter/update/${subscriberId}`,
        method: "PATCH",
        data: payload
      })
  });
}
